export class GetReadyFullConstants {
  static POST_SOLICITATION_ERROR = 'POST_SOLICITATION_ERROR';

  static GET_SOLICITATION_SUCCESS = 'GET_SOLICITATION_SUCCESS';
  static GET_SOLICITATION_ERROR = 'GET_SOLICITATION_ERROR';

  static PATCH_PROSPECT_SUCCESS = 'PATCH_PROSPECT_SUCCESS';
  static PATCH_PROSPECT_ERROR = 'PATCH_PROSPECT_ERROR';
}
